export const BOX_RANGE = '$$range$$';
export const BOX_RANGE_ALIAS = 'low-q1-median-q3-high';

export const BOX_SYNC_NAME = '$$y_outliers$$';

export const OUTLIERS_VIEW_ID = 'outliers_view';
